import { React, useState, useEffect, useRef } from "react";
import clsx from "clsx";
import {  Form, Container } from "react-bootstrap";
import { useHistory } from "react-router";
import Image from "react-bootstrap/Image";
import _ from "lodash";
import * as userSelectors from "../../../selectors/user";
import { useDispatch, useSelector } from "react-redux";
import * as axiosInstance from "../../../services/axiosInstance";
import useEDepositData from "../../../hooks/useEDepositData.js";
import { useForm, Controller } from "react-hook-form";
import * as authSelectors from "../../../selectors/auth";
import * as StorageManager from "../../../utils/StorageManager";
import constants from "../../../constants";
import LoadingOverlay from "../../../components/LoadingOverlay";
import Enviornment from "../../../utils/Enviornment";
import CurrencyInput from "react-currency-input-field";
import { useLocation } from "react-router-dom";


function DepositOnlineFPX({ label, items }) {
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(false);
  const [initialValues, setInitialValues] = useState(null);
  const [paymentResponse, setResponseData] = useState(null);

  const location = useLocation();
  const postData = location.state;
  const postAccountId = _.get(postData, ["selectedAccountId"], null);
  const postSelectedCurrency = _.get(postData, ["selectedCurrencyId"], null);

  let history = useHistory();
  const dispatch = useDispatch();
  const userState = useSelector((state) => state.user);
  const isLogout = useSelector((state) => authSelectors.getAuthIsLogout(state));
  const formRef = useRef(null);

  const accountSelections = userSelectors.getUserAccountSelections(userState);
  const selectedAccount = _.find(accountSelections, "is_selected");
  const currenciesSelections = userSelectors.getUserAccountSelectionsCurrencies(selectedAccount);
  const selectedCurrency = _.find(currenciesSelections, "is_selected");
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    watch,
  } = useForm({ defaultValues: {client_code: postAccountId, currency_code: postSelectedCurrency && postSelectedCurrency.key}, values: initialValues });

  const tradeId = userSelectors.getUserAccountText(selectedAccount);
  const currency = userSelectors.getUserAccountText(selectedCurrency);
  useEffect(() => {
    setTokenFunction();
  }, [isLogout]);

  async function setTokenFunction() {
    setToken(await StorageManager.retrieveToken(constants.AUTH_TOKEN));
  }
  const handleBack = (e) => {
    e.preventDefault()
    history.goBack();
  };

  const onSubmit = async (values) => {
    setLoading(true);

    values.success_redirect_url = `${Enviornment.DEPOSIT_REDIRECT_URL}`;
    values.failure_redirect_url = `${Enviornment.DEPOSIT_REDIRECT_URL}`;

    try {
      const response = await axiosInstance.post("clientarea/deposit/online-payment", values, true, false);
      const paymentResponse = _.get(response, ["payment_request", "data"], null);
      setResponseData(paymentResponse);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const { data } = useEDepositData(token);
  const depositFpxBank = _.get(data, ["fpx_banks"], null);

  useEffect(() => {
    if (paymentResponse) {
      const form = document.createElement("form");
      form.method = "POST";
      form.action = paymentResponse.url;

      for (const key in paymentResponse) {
        if (key === "url") continue;

        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = paymentResponse[key];
        form.appendChild(input);
      }

      formRef.current.appendChild(form);
      form.submit();
    }
  }, [paymentResponse]);

  return (
      <Container fluid>
        <div className={"primary-border-table-border"} style={{backgroundColor: "white"}}>
          <div className={clsx("custom-card-label-container text-center")}>
            <h2>Deposit Online FPX Payment</h2>
          </div>
          <br/>
          <div className="fpx-transfer-content">
            <div className="fpx-transfer-content-inner">
              <div className="fpx-transfer-content-input padding-12px">
                <p className="fpx-transfer-content-inner-label">Pay with </p>
                <div className="fpx-logo-content">
                  <Image src="/img/fpx-logo-2.png" rounded style={{width: "100px"}}/>
                  <p>( Current & Savings Account )</p>
                </div>
              </div>
              <Form onSubmit={handleSubmit(onSubmit)} className="mt-3">
                <div className="fpx-transfer-content-input padding-12px my-2">
                  <p className="fpx-transfer-content-inner-label">Client Code</p>
                  <Form.Group className="w-100">
                    <Form.Control type="text" {...register("client_code")} disabled/>
                  </Form.Group>
                </div>
                {/*<div className="fpx-transfer-content-input padding-12px my-2">*/}
                {/*  <p className="fpx-transfer-content-inner-label">Currency</p>*/}
                {/*  <Form.Group className="w-100">*/}
                {/*    /!*<Form.Control type="text" value={postSelectedCurrency} disabled />*!/*/}
                {/*    <Form.Control type="text" {...register("postSelectedCurrency")} disabled />*/}
                {/*  </Form.Group>*/}
                {/*</div>*/}
                <div className="fpx-transfer-content-input padding-12px my-2">
                  <p className="fpx-transfer-content-inner-label">Amount
                    ({selectedCurrency && selectedCurrency.text})</p>
                  <Form.Group className="w-100">
                    {/*<Form.Control*/}
                    {/*    isInvalid={!_.isEmpty(errors && errors.amount)}*/}
                    {/*    name="amount"*/}
                    {/*    type="number"*/}
                    {/*    {...register("amount", { required: "Amount is required" })}*/}
                    {/*/>*/}
                    <Controller
                        name="amount"
                        control={control}
                        rules={{required: "Amount is required"}}
                        render={({field}) => (
                            <CurrencyInput
                                placeholder="0"
                                className={clsx("form-control w-100", {"is-invalid": errors.amount})}
                                decimalsLimit={2}
                                value={field.value}
                                onValueChange={field.onChange}
                            />
                        )}
                    />
                    {errors.amount && (
                        <Form.Control.Feedback type="invalid">{errors.amount.message}</Form.Control.Feedback>
                    )}
                  </Form.Group>
                </div>
                <div className="fpx-transfer-content-input padding-12px my-2">
                  <p className="fpx-transfer-content-inner-label">Select Bank</p>
                  <Form.Group className="w-100">
                    <Form.Select {...register("bank_id")}>
                      <option value="">Select Bank</option>
                      <optgroup label="Retail Banking:">
                        {_.map(depositFpxBank, (bank, index) => {
                          const code = _.get(bank, ["code"], "");
                          const name = _.get(bank, ["name"], "");
                          const status = _.get(bank, ["status"], "");
                          return (
                              <option disabled={status === "B"} key={index} value={code}>
                                {name}
                                {status === "B" ? ` (Offline)` : ""}
                              </option>
                          );
                        })}
                      </optgroup>
                    </Form.Select>
                  </Form.Group>
                </div>
                <div className="fpx-transfer-content-input padding-12px my-2">
                  <p className="fpx-transfer-content-inner-label">Client Remark</p>
                  <Form.Group className="w-100">
                    <Form.Control name="client_remark" type="text" {...register("client_remarks")} />
                  </Form.Group>
                </div>
                <p className="my-3 padding-12px ">
                  By clicking on <span className="text-bold-600">“Proceed”</span> button, you hereby agree with
                  <a href={Enviornment.FPX_TERM_AND_CONDITIONS_LINK} target="_blank">
                    {` FPX’s Terms & Conditions`}
                  </a>
                </p>
                <div className="d-flex justify-content-center py-3">
                  <button className={clsx("btn custom-button-back")} onClick={handleBack}>
                    Back
                  </button>
                  <button
                      className={clsx("btn custom-button-primary")}
                      type="submit"
                      style={{backgroundColor: "#9D7905"}}
                      disabled={_.isEmpty(watch('bank_id'))}
                  >
                    Proceed
                  </button>
                </div>
                <div className={clsx("payment-card-title mt-3 justify-content-end w-100")}>
                  <h6>Powered By</h6>
                  <img src="/img/fpx-logo-2.png" className="payment-card-watermark-image"></img>
                </div>
              </Form>
            </div>
            <LoadingOverlay loading={loading}></LoadingOverlay>
          </div>
          <div ref={formRef}></div>
          <br/>
        </div>
      </Container>
  );
}

export default DepositOnlineFPX;
